import { Col, DatePicker, Form, Input, Layout, Radio, Row, TimePicker, theme } from 'antd';
import {
    SendOutlined,
    MoreOutlined,
    MessageOutlined,
    UnlockOutlined,
    EyeOutlined,
    LockOutlined,
    EditOutlined
} from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

const { Search } = Input;
const { Header, Sider, Content } = Layout;


const options = [
    {
        label: 'After Meeting',
        value: 'after',
    },
    {
        label: 'Custom Timing',
        value: 'custom',
    },
];
export default function VotingEnd({
    setVotingData,
    votingData = {},
    allowVoting,
    drawerOpenAction
}) {
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();
    const [form] = Form.useForm();
    const actionState = useSelector(state => state.meeting.actionState);

    const [votingEndTypeValue, setVotingEndTypeValue] = useState('after');
    const [customDate, setCustomDate] = useState(null);

    useEffect(() => {
        // console.log('drawerOpenAction :', drawerOpenAction)
        // console.log('agendaItemOpenState :', agendaItemOpenState)
        // console.log('votingData :', votingData)
        // console.log('allowVoting :', allowVoting)
    }, [drawerOpenAction, allowVoting])

    useEffect(() => {
        const {end} = votingData;
        setVotingEndTypeValue(end?.type ? end?.type : 'after');
        const customeDateValue = end?.customDate ? dayjs(end.customDate) : null
        form.setFieldsValue({customDate: customeDateValue})

        if(allowVoting){
            setVotingData({
                isEnabled: allowVoting,
                end: {
                    type: end?.type ? end.type : 'after',
                    customDate: end?.type === 'custom' ? end?.customDate : null
                }
            })
        }
    }, [drawerOpenAction, allowVoting])

    const onChange = ({ target: { value } }) => {
        setVotingEndTypeValue(value);
        setVotingData({
            isEnabled: allowVoting,
            end: {
                type: value,
                customDate: value === 'custom' ? customDate?.format('YYYY-MM-DD HH:mm') : null,
            }
        })
    };

    const onDateChange = (date) => {
        console.log('onDateChange :', date)
        setCustomDate(date);
        setVotingData({
            isEnabled: true,
            end: {
                type: votingEndTypeValue,
                customDate: votingEndTypeValue === 'custom' ? dayjs(date).toISOString() : null,
            }
        });
    };

    const handleValidateDate = (_, value) => {
        if (value && value.isBefore(dayjs(), 'day')) {
            return Promise.reject(new Error('Date cannot be earlier than today.'));
        }
        return Promise.resolve();
    };

    return (
        <>
            <Form form={form}>
                <Form.Item>
                    <Radio.Group 
                        options={options} 
                        onChange={onChange} 
                        value={votingEndTypeValue} optionType="button" disabled={drawerOpenAction === 'view'} />
                </Form.Item>
                <br />

                {votingEndTypeValue === 'custom' && (
                    <Row>
                        <Col span={12}>
                            <Form.Item label='Select Date and time' name="customDate" rules={[
                                { validator: handleValidateDate }
                            ]}>
                                <DatePicker
                                    showTime={{
                                        format: 'HH:mm',
                                    }}
                                    style={{ width: '100%' }}
                                    onChange={onDateChange}
                                    disabled={drawerOpenAction === 'view'}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                )}
            </Form>

        </>
    )
}